// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__yYR0Z","savePackageButton":"ClientWallet_savePackageButton__3yiqO"};